import { tradeWindfallReferralRule } from './tradeWindfallReferralRule';
import { tradeWindfallReferralAction } from './tradeWindfallReferralAction';

export default {
    name: 'tradeWindfallReferral',
    priority: 480,
    rule: tradeWindfallReferralRule,
    action: tradeWindfallReferralAction,
};
